var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRentalCategories = function SvgRentalCategories(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 48,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-3.8%",
    y: "-75%",
    width: "107.5%",
    height: "250%",
    filterUnits: "objectBoundingBox",
    id: "rental-categories_svg__b"
  }, /*#__PURE__*/React.createElement("feOffset", {
    "in": "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    "in": "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.34902 0 0 0 0 0.494118 0 0 0 0 0.968627 0 0 0 0.06 0",
    "in": "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    "in": "SourceAlpha",
    result: "shadowOffsetOuter2"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    "in": "shadowOffsetOuter2",
    result: "shadowBlurOuter2"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.031373 0 0 0 0 0.039216 0 0 0 0 0.145098 0 0 0 0.05 0",
    "in": "shadowBlurOuter2",
    result: "shadowMatrixOuter2"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "shadowMatrixOuter2"
  }))), /*#__PURE__*/React.createElement("filter", {
    x: "-2.7%",
    y: "-21.5%",
    width: "105.4%",
    height: "143%",
    filterUnits: "objectBoundingBox",
    id: "rental-categories_svg__d"
  }, /*#__PURE__*/React.createElement("feOffset", {
    "in": "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    "in": "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.711052012 0 0 0 0 0.751658486 0 0 0 0 0.884454257 0 0 0 1 0",
    "in": "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-3.8%",
    y: "-75%",
    width: "107.5%",
    height: "250%",
    filterUnits: "objectBoundingBox",
    id: "rental-categories_svg__g"
  }, /*#__PURE__*/React.createElement("feOffset", {
    "in": "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    "in": "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.34902 0 0 0 0 0.494118 0 0 0 0 0.968627 0 0 0 0.06 0",
    "in": "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    "in": "SourceAlpha",
    result: "shadowOffsetOuter2"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    "in": "shadowOffsetOuter2",
    result: "shadowBlurOuter2"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.031373 0 0 0 0 0.039216 0 0 0 0 0.145098 0 0 0 0.05 0",
    "in": "shadowBlurOuter2",
    result: "shadowMatrixOuter2"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "shadowMatrixOuter2"
  }))), /*#__PURE__*/React.createElement("filter", {
    x: "-3%",
    y: "-21%",
    width: "105.9%",
    height: "142%",
    filterUnits: "objectBoundingBox",
    id: "rental-categories_svg__i"
  }, /*#__PURE__*/React.createElement("feOffset", {
    "in": "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    "in": "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.711052012 0 0 0 0 0.751658486 0 0 0 0 0.884454257 0 0 0 1 0",
    "in": "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-3.8%",
    y: "-75%",
    width: "107.5%",
    height: "250%",
    filterUnits: "objectBoundingBox",
    id: "rental-categories_svg__l"
  }, /*#__PURE__*/React.createElement("feOffset", {
    "in": "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    "in": "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.349019608 0 0 0 0 0.494117647 0 0 0 0 0.968627451 0 0 0 0.06 0",
    "in": "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    "in": "SourceAlpha",
    result: "shadowOffsetOuter2"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    "in": "shadowOffsetOuter2",
    result: "shadowBlurOuter2"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.031372549 0 0 0 0 0.0392156863 0 0 0 0 0.145098039 0 0 0 0.05 0",
    "in": "shadowBlurOuter2",
    result: "shadowMatrixOuter2"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "shadowMatrixOuter2"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "rental-categories_svg__a",
    x: 0,
    y: 0,
    width: 80,
    height: 4,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rental-categories_svg__f",
    x: 0,
    y: 0,
    width: 80,
    height: 4,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rental-categories_svg__k",
    x: 0,
    y: 0,
    width: 80,
    height: 4,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "rental-categories_svg__e",
    d: "M0-1.016v6.984h55.309v-6.984z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rental-categories_svg__j",
    d: "M0-.952V6.19h50.69V-.952z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 22)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "rental-categories_svg__c",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rental-categories_svg__a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#rental-categories_svg__b)",
    xlinkHref: "#rental-categories_svg__a"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#rental-categories_svg__a"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#rental-categories_svg__c)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#rental-categories_svg__d)",
    xlinkHref: "#rental-categories_svg__e"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#40A9FF",
    xlinkHref: "#rental-categories_svg__e"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFC53D",
    mask: "url(#rental-categories_svg__c)",
    d: "M75.041-.635V6.35h4.938V-.635z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF7A45",
    mask: "url(#rental-categories_svg__c)",
    d: "M55.19-.571v6.984h19.872V-.571z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "rental-categories_svg__h",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rental-categories_svg__f"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#rental-categories_svg__g)",
    xlinkHref: "#rental-categories_svg__f"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#D8D8D8",
    xlinkHref: "#rental-categories_svg__f"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#rental-categories_svg__h)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#rental-categories_svg__i)",
    xlinkHref: "#rental-categories_svg__j"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#37A3BC",
    xlinkHref: "#rental-categories_svg__j"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFC53D",
    mask: "url(#rental-categories_svg__h)",
    d: "M69.43-.476v7.143H80V-.476z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BAE637",
    mask: "url(#rental-categories_svg__h)",
    d: "M50.69-.476v7.143h18.74V-.476z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 44)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "rental-categories_svg__m",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rental-categories_svg__k"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#rental-categories_svg__l)",
    xlinkHref: "#rental-categories_svg__k"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#rental-categories_svg__k"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B37FEB",
    mask: "url(#rental-categories_svg__m)",
    d: "M0-1.016v6.984h63.694v-6.984z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#36CFC9",
    mask: "url(#rental-categories_svg__m)",
    d: "M75.041-.635V6.35h4.938V-.635z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF7A45",
    mask: "url(#rental-categories_svg__m)",
    d: "M63.597-.571v6.984h11.465V-.571z"
  })))));
};
export default SvgRentalCategories;